var _circle, _path, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStrength(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#F8F7FF",
    stroke: "url(#paint0_linear_1062_58)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2296 43.0652C33.4257 48.3023 29.6309 55.1386 28.2694 62.8087C27.8827 64.9877 27.8989 65.4646 28.4052 66.7988C30.1242 71.3308 37.3563 75.0039 44.5612 75.0039C47.3481 75.0039 51.5079 74.2155 53.5731 73.2956C55.3068 72.5235 55.7489 72.6245 57.1259 74.1068L57.9594 75.0039H64.5601C69.8879 75.0039 71.2401 74.9077 71.5718 74.5052C72.0193 73.9622 72.1781 54.9396 71.7443 53.8016C71.4285 52.9731 70.3347 53.0461 67.467 54.0879L65.0231 54.9756L63.4075 54.1744C62.0794 53.5158 61.2424 53.3739 58.6988 53.3763C56.0252 53.3791 55.3718 53.5033 53.8866 54.2907C52.9413 54.7918 51.885 55.5172 51.5392 55.9024C50.9594 56.5486 50.8201 56.5648 49.7456 56.1128C48.1356 55.4355 46.2568 55.512 44.4715 56.3274L42.9621 57.0168L43.1598 55.3383C43.2681 54.4149 43.7025 52.9433 44.125 52.0684L45 50.4771L45.8458 49.0039L50.5521 46.0371C49.2226 44.0821 44.8925 42.3212 44.8925 41.0005C44.8925 40.4432 41.2367 42.094 41 42.0206C40.6789 41.9209 40.113 42.268 39.2296 43.0652ZM28.0216 64.7942C28.0254 65.5556 28.0958 65.8262 28.178 65.3957C28.2601 64.9652 28.257 64.3422 28.1711 64.0113C28.0852 63.6805 28.0178 64.0328 28.0216 64.7942Z",
    fill: "#393184"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1062_58)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 38.5,
    r: 13.5,
    fill: "url(#paint1_linear_1062_58)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 38.5,
    r: 13.5,
    stroke: "url(#paint2_linear_1062_58)",
    strokeWidth: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_1062_58)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 38.5,
    r: 6.5,
    fill: "url(#paint3_linear_1062_58)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 38.5,
    r: 6.5,
    stroke: "url(#paint4_linear_1062_58)",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1062_58",
    x: 36.85,
    y: 22.85,
    width: 31.3,
    height: 31.3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1062_58"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1062_58",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_1062_58",
    x: 43.85,
    y: 29.85,
    width: 17.3,
    height: 17.3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1062_58"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1062_58",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1062_58",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DEDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1062_58",
    x1: 41.8893,
    y1: 27.4911,
    x2: 71.0322,
    y2: 42.5809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1062_58",
    x1: 54.75,
    y1: 29.5,
    x2: 64.875,
    y2: 53.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1062_58",
    x1: 47.3911,
    y1: 33.1994,
    x2: 61.4229,
    y2: 40.4649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1062_58",
    x1: 53.5833,
    y1: 34.1667,
    x2: 58.4583,
    y2: 45.5417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrength);
export default __webpack_public_path__ + "static/media/strength.06c2523128173023eda0a64d464e405d.svg";
export { ForwardRef as ReactComponent };